var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"totem-last-watched-tag"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('UncompletedCourses.last_watched'))}}),_c('span',[_vm._v(_vm._s(_vm.getFormattedTimeSinceLastWatched(_vm.course.lastActivityDateAndTime)))])])}
var staticRenderFns = []

export { render, staticRenderFns }